import { render, staticRenderFns } from "./CoursePicker.vue?vue&type=template&id=12e54728"
import script from "./CoursePicker.vue?vue&type=script&lang=js"
export * from "./CoursePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports